var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"item-left"},[_vm._v("\n    "+_vm._s(_vm.info.get('content'))+"\n  ")]),_c('div',{staticClass:"item-right"},[_vm._v("\n    "+_vm._s(_vm.infoDate(_vm.info))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }